import React from 'react'
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';
import LocationDisabledIcon from '@material-ui/icons/LocationDisabled';
import Tr from 'translations/Translations';
import IconButton from './IconButton';

function IconExternalSignButton({
    enabled,
    ...props
}) {
    return <IconButton
        tooltip={Tr(enabled ? 'rfx_supplier_disable_externalSign' : 'rfx_supplier_enable_externalSign')}
        Icon={enabled ? LocationDisabledIcon : LocationSearchingIcon}
        {...props}
    />
}

export default IconExternalSignButton;